module.exports = __webpack_public_path__ + "img/MOC Set Order.ef5b2a18.png";